module.exports = __webpack_public_path__ + "static/img/search_bar_search.cbb2b3c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/search_bar_search.svg
// module id = HVNE
// module chunks = 1